import React from "react"
import UploadGroupBuilder from "../../UploadGroupBuilder/UploadGroupBuilder"

export default class ProductPresenterImages extends React.Component {
  
  constructor(props) {
    super(props);
  };

  render() {
    return(
      <div className="images">
        <div className="row">
          <div className="col-md-12">
            <UploadGroupBuilder upload_type="image" upload_type_plural="images" upload_groups={this.props.product && this.props.product.image_group ? [this.props.product.image_group] : [{ images: [] }]} read_only={true} helperText="images_helper_text"/>
          </div>
        </div>
      </div>
    );
  };
};